import { EventModeEnum } from 'api/events/events.enum';

export const EVENT_MODE_NUMBERS = Object.values(EventModeEnum).filter(Number.isInteger);
